import { Eye } from "lucide-react";
import { Reveal, ChapterLabel } from "./Reveal";
import { FOCUS_AREAS } from "../data/content";

export const Focus = () => (
  <section
    id="focus"
    data-testid="focus-section"
    className="border-t border-[#E5DFD3] bg-[#F5F0E8]/60"
  >
    <div className="mx-auto max-w-6xl px-6 py-24 lg:px-10 lg:py-36">
      <Reveal>
        <ChapterLabel number="02" label="Focus" />
        <h2
          data-testid="focus-title"
          className="font-display mt-6 text-3xl font-light tracking-tight text-[#1B3A5C] sm:text-4xl lg:text-5xl"
        >
          Areas of clinical focus
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-2 lg:mt-20 lg:gap-10">
        {FOCUS_AREAS.map((area, i) => (
          <Reveal key={area.title} delay={0.15 + i * 0.15}>
            <article
              data-testid={`focus-card-${i + 1}`}
              className="group h-full border border-[#C9A66B]/25 bg-white p-8 transition-[border-color,transform] duration-500 hover:-translate-y-1 hover:border-[#C9A66B]/60 lg:p-12"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-full border border-[#C9A66B]/50 text-[#C9A66B] transition-colors duration-500 group-hover:bg-[#C9A66B]/10">
                  <Eye size={20} strokeWidth={1.25} />
                </span>
                <span className="font-display text-2xl font-light italic text-[#C9A66B]/70">
                  {area.number}
                </span>
              </div>
              <h3 className="font-display mt-8 text-xl font-normal text-[#1B3A5C] lg:text-2xl">
                {area.title}
              </h3>
              <p className="mt-4 text-[15px] leading-relaxed text-[#555]">{area.body}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
